export const TAG_TYPE = {
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
};

export const STATE_LABELS = {
  IN_PROGRESS: {
    key: 'reportsScreen.state.inProgress',
    tag: TAG_TYPE.WARNING,
  },
  CREATED: {
    key: 'reportsScreen.state.created',
    tag: TAG_TYPE.SUCCESS,
  },
  FAILED: {
    key: 'reportsScreen.state.failed',
    tag: TAG_TYPE.ERROR,
  },
};

export const REPORT_TYPE_LABELS = {
  DATA_RANGE: 'reportsScreen.type.dateRange',
  SCHEDULED: 'reportsScreen.type.scheduled',
};
